// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"e0a87a76","201":"32525491","248":"3e21596a","516":"b2cf26d0"}[chunkId] + ".chunk.js";
};